module.exports = __webpack_public_path__ + "static/media/stack-star.ccff19f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/stack-star.svg
// module id = 3577
// module chunks = 7